import React, { Dispatch, SetStateAction } from 'react';

import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Divider, Drawer, Typography } from '@mui/material';

import { Resource } from '../../../common/constants/resource';
import styles from './styles.module.scss';

export const InvalidDrawer = ({
  isOpen,
  setIsOpen,
  labelCopy,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  labelCopy: string;
}) => {
  const classNames = [
    styles.RequiredFieldBackground,
    styles.RequiredFieldText,
    styles.RequiredFieldWidePadding,
  ].join(' ');

  return (
    <Drawer
      open={isOpen}
      anchor="right"
      variant="persistent"
      classes={{ paper: styles.Drawer }}
      transitionDuration={{ enter: 0, exit: 0 }}
    >
      <Box mt={6}>
        <Box
          m={3}
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body1">{labelCopy}</Typography>
          <Button onClick={() => setIsOpen(false)}>
            <Typography variant="subtitle2" color="textSecondary">
              Cancel
            </Typography>
          </Button>
        </Box>
        <Divider />
        <Box m={3}>
          <Box
            className={classNames}
            display="flex"
            flexDirection="row"
            alignItems="center"
          >
            <Box mr={2}>
              <FontAwesomeIcon icon={faExclamationTriangle} />
            </Box>
            <Box>{Resource.INVALID_TASK_STATE_ERROR}</Box>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};
